import { jsx, jsxs } from 'react/jsx-runtime';
import { useRef } from 'react';
import { Grid, FormControl, InputLabel, Select as Select$1, MenuItem } from '@mui/material';

const Select = ({ label, value = '', options, name, handleChange, }) => {
    const inputLabel = useRef(null);
    return (jsx(Grid, Object.assign({ item: true, lg: 6, md: 12, sm: 12, xs: 12 }, { children: jsxs(FormControl, Object.assign({ fullWidth: true }, { children: [jsx(InputLabel, Object.assign({ ref: inputLabel }, { children: label })), jsxs(Select$1, Object.assign({ value: value, onChange: handleChange, inputProps: {
                        name: `${name}`,
                    } }, { children: [jsx(MenuItem, Object.assign({ value: "" }, { children: jsx("em", { children: "Selecione um valor" }) })), options.map((answer, index) => {
                            return (jsx(MenuItem, Object.assign({ value: answer.Resposta }, { children: answer.Resposta }), `${answer.Resposta}-${index}`));
                        })] }))] })) })));
};

export { Select };
